import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from 'src/service/language-management.service';
import { FocusInputType, KeyValues30, KeyValueSet, LocalService, NumericConfig, Status, TaskStatus, TaskUpdateType } from 'src/service/local.service';
import { TaskManagementService } from 'src/service/task-management.service';

@Component({
  selector: 'app-task-request',
  templateUrl: './task-request.component.html',
  styleUrl: './task-request.component.scss'
})
export class TaskRequestComponent {
  @ViewChild('content_task_request')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  lstSectionConfigKeys: string[] = ["tasks"]; TaskStatus = TaskStatus;
  @Input() taskId: string = ''; userId: string = ''; data: KeyValues30; @Input() parentTaskNumber: string = '';
  @Input() taskOwners: KeyValueSet[] = []; @Input() taskTypes: KeyValueSet[] = []; @Input() taskStatuses: KeyValueSet[] = [];

  htmlId: string = ''; elementIds: any; sideBarBodyHeight: number = 10;
  numericConfig: NumericConfig = { isDecimalAllowed: false, isNegativeAllowed: false } as NumericConfig;
  isTaskIdAvailable: boolean = false; isParentTaskNumber: boolean = false; isFreeze: boolean = false;
  currentTaskType: string = ''; currentTaskStatus: string = '';

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private languageManagementService: LanguageManagementService, private taskManagementService: TaskManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      title: 'txt_title' + this.htmlId,
      customer_contact: 'txt_customer_contact' + this.htmlId,
      task_type: 'txt_task_type' + this.htmlId,
      comment: 'txt_comment' + this.htmlId,
      customer_detail: 'txt_customer_detail' + this.htmlId,
      closing_comment: 'txt_closing_comment' + this.htmlId,
      blocked_task: 'txt_blocked_task' + this.htmlId
    }
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onReset() {
    this.userId = this.localService.selected.user;
    this.isTaskIdAvailable = this.taskId && this.taskId.length > 5 ? true : false;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    this.onReset();
    this.taskManagementService.getTaskRequest(this.taskId, this.parentTaskNumber).subscribe(result => {
      this.data = result;
      this.isParentTaskNumber = result.v9 == '1';
      this.isFreeze = [TaskStatus.Aborted, TaskStatus.Completed].includes(parseInt(result.v5));
      if (this.isTaskIdAvailable) {
        this.currentTaskStatus = this.localService.getText(this.taskStatuses, result.v5);
        this.currentTaskType = this.localService.getText(this.taskTypes, result.v4);
      }
    });
    setTimeout(() => {
      this.sideBarBodyHeight = window.outerHeight - 120;
      if (!this.isTaskIdAvailable) {
        this.localService.onFocusNextInput(this.elementIds.title, FocusInputType.TextBox);
      } else {
        this.localService.onFocusNextInput(this.elementIds.closing_comment, FocusInputType.TextBox);
      }
    }, 100);
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.onSave();
      } break;
      case 2: {
        this.data.v3 = this.localService.selected.user;
      } break;
      case 3: {
        this.onUpdate(TaskUpdateType.Primary);
      } break;
      case 4: {
        this.onUpdateTaskStatus(TaskStatus.InProgress);
      } break;
      case 5: {
        this.onUpdate(TaskUpdateType.Comment);
      } break;
      case 6: {
        this.onUpdateTaskStatus(TaskStatus.Aborted);
      } break;
      case 7: {
        this.onUpdateTaskStatus(TaskStatus.Completed);
      } break;
      case 8: {
        this.onUpdate(TaskUpdateType.AddBlock);
      } break;
      case 9: {
        this.onUpdateTaskStatus(TaskStatus.Blocked);
      } break;
    }
  }

  onSave() {
    this.data.v7 = this.parentTaskNumber;
    this.taskManagementService.createTaskRequest(this.data).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.onCloseTrigger();
      }
    });
  }

  onUpdateTaskStatus(toTaskStatus: TaskStatus) {
    this.taskManagementService.updateTaskStatus(this.taskId, toTaskStatus, this.data.v11).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.onLoad();
      }
    });
  }

  onUpdate(taskUpdateType: TaskUpdateType) {
    this.data.v7 = this.parentTaskNumber;
    this.taskManagementService.updateTaskRequest(this.data, taskUpdateType).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.onLoad();
      }
    });
  }
}
